// Réactions pour la diversification
const REACTION_LABELS = {
  liked: '😋 A aimé',
  neutral: '😐 Neutre',
  disliked: '😖 N\'a pas aimé',
  allergy: '⚠️ Réaction'
};

export const formatEventData = (event) => {
  const data = JSON.parse(event.data);
  switch (event.type) {
    case 'feeding':
      let feedingResult;
      if (data.mode === 'biberon') {
        feedingResult = `${data.amount_ml}ml - ${data.milk_type === 'lait_infantile' ? 'Lait infantile' : 'Lait maternel'}`;
      } else {
        feedingResult = `Sein ${data.mode.replace('sein_', '')}`;
      }
      // Ajouter les infos de diversification si présentes
      if (data.foods && Array.isArray(data.foods) && data.foods.length > 0) {
        // Nouveau format multi-aliments
        const foodsStr = data.foods.map(f => f.emoji || '🥄').join('');
        feedingResult += ` + ${foodsStr}`;
      } else if (data.food_name) {
        // Ancien format mono-aliment (rétrocompatibilité)
        feedingResult += ` + ${data.food_emoji || '🥄'} ${data.food_name}`;
        if (data.reaction) {
          feedingResult += ` (${REACTION_LABELS[data.reaction] || data.reaction})`;
        }
      }
      return feedingResult;
    case 'diaper':
      const items = [];
      if (data.urine) items.push('urine');
      if (data.stool) items.push(`selles (${data.stool_type})`);
      return items.join(' + ');
    case 'temperature':
      return `${data.value}°C`;
    case 'bath':
      return 'Bain donné';
    default:
      return '';
  }
};

export const getEventIcon = (type) => {
  const icons = {
    feeding: '🍼',
    diaper: '👶',
    temperature: '🌡️',
    bath: '💧'
  };
  return icons[type] || '📝';
};

export const getEventTitle = (type) => {
  const titles = {
    feeding: 'Repas',
    diaper: 'Couche',
    temperature: 'Température',
    bath: 'Bain'
  };
  return titles[type] || 'Événement';
};